import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { ErrorHttpResponse, HttpConfig } from '../../../../models/https';
import useHttps from '../../../useHttps';
import { useAppDisPatch } from '../../../../redux/store';
import { setBannerNotifications } from '../../../../redux/slices/bannerNotificationsSlice';

const useGetBannerNotifications = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetBannerNotificationsError = (
    err: AxiosError<ErrorHttpResponse>
  ) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching banner notifications'
    );
  };

  const onGetBannerNotificationsSuccess = useCallback(
    (response: any) => {
      const notificationsData = response?.data || response;
      // Dispatch the action with the received data
      dispatch(setBannerNotifications(notificationsData));
      return notificationsData;
    },
    [dispatch]
  );

  const getBannerNotifications = useCallback(() => {
    const urlPath = `notifications/banner-notifications/notifications`;
    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    return request(
      url,
      onGetBannerNotificationsSuccess,
      setLoading,
      onGetBannerNotificationsError
    );
  }, [request, onGetBannerNotificationsSuccess]);

  return { getBannerNotifications, loading };
};

export default useGetBannerNotifications;
